<template>
  <div>
    <el-form :rules="rules" :model="form" ref="elForm">
      <el-form-item prop="password1">
        <el-input type="password" placeholder="请输入您的新密码" v-model="form.password1" />
      </el-form-item>
      <el-form-item prop="password2">
        <el-input type="password" placeholder="请再次输入您的新密码" v-model="form.password2" />
      </el-form-item>
    </el-form>
    <el-button type="primary" class="btn-ok btn-top" @click="onOK">确认</el-button>
  </div>
</template>

<script>
  import baseApi from '@/dss-common/api/base'

  export default {
    data() {
      const checkPwd = (rules, value, callback) => {
        if (this.form.password1 !== value) {
          return callback(new Error('密码不匹配'));
        }
        return callback();
      }
      return {
        form: {
          password1: '',
          password2: ''
        },
        rules: {
          password1: {
            required: true,
            message: '请输入您的新密码'
          },
          password2: [{
            required: true,
            message: '请再次输入您的新密码',

          },{ validator: checkPwd, trigger: 'blur' }]
        }
      };
    },
    methods: {
      onOK() {
        this.$refs.elForm.validate(valid => {
          if (!valid) {
            return;
          }
          this.submit();
        });
      },
      submit() {
        baseApi.changePwd(this.form).done(() => {
          this.$emit('ok');
        });
      }
    }
  }
</script>
